import { render, staticRenderFns } from "./CChart.vue?vue&type=template&id=58dee271"
import script from "./CChart.vue?vue&type=script&lang=ts"
export * from "./CChart.vue?vue&type=script&lang=ts"
import style0 from "./CChart.vue?vue&type=style&index=0&id=58dee271&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports